import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as componentTypes from "../../../../constants/componentTypes";
import * as priceTypes from "../../../../constants/priceTypes";
import * as marginActions from "../../../../actions/marginActions";
import * as navigationActions from "../../../../actions/navigationActions";
import * as validationHelper from "../../../../helpers/validationHelper";
import * as formatHelper from "../../../../helpers/formatHelper";
import * as settings from "../../../../constants/settings";
import * as tooltipHelper from "../../../../helpers/tooltipHelper";
import * as modelHelper from "../../../../helpers/modelHelper";

import Button from "../../../global/generic/Button";
import CancelButton from "../../../global/generic/CancelButton";
import Input from "../../../global/generic/Input";
import Modal from "../../../global/generic/Modal";

import imgConfirm from "../../../../resources/img/svgicons/confirm.svg";

class EditMarginModal extends Component {
    constructor(props) {
        super(props);

        if (this.props.params?.margin) {
            this.state = {
                type: this.props.params.margin.type ?? 0,
                name: this.props.params.margin.name,
                valueForBases: String(formatHelper.convertDecimalToPercent(this.props.params.margin.procBases)),
                valueForColorants: String(formatHelper.convertDecimalToPercent(this.props.params.margin.procColorants))
            };
        } else {
            this.state = {
                type: this.getDefaultMarginType(props),
                valueForBases: "",
                name: "",
                valueForColorants: ""
            };
        }
    }
    getDefaultMarginType = (props) => {
        if (props.showMargin) {
            return priceTypes.MARGIN_TYPE_MARGIN;
        }

        if (props.showMarkup) {
            return priceTypes.MARGIN_TYPE_MARKUP;
        }

        if (props.showDiscount) {
            return priceTypes.MARGIN_TYPE_DISCOUNT;
        }

        return settings.OPTION_NONE;
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseMarginModalAction();
    };

    handleInputFocus = (event) => {
        event.target.select();
    };

    handleMarginTypeChange = (event) => {
        let marginType = Number(event.target.value);

        this.setState({
            type: marginType,
            valueForBases: validationHelper.isMarginMarkupDiscountValid(marginType, this.state.valueForBases)
                ? this.state.valueForBases
                : "",
            valueForColorants: validationHelper.isMarginMarkupDiscountValid(marginType, this.state.valueForColorants)
                ? this.state.valueForColorants
                : ""
        });
    };

    handleNewMarginNameChange = (event) => {
        this.setState({
            name: event.target.value
        });
    };

    handleNewValueForBasesChange = (event) => {
        if (validationHelper.isMarginMarkupDiscountValid(this.state.type, event.target.value)) {
            this.setState({
                valueForBases: event.target.value
            });
        }
    };

    handleNewValueForBasesBlur = (event) => {
        this.setState({
            valueForBases: validationHelper.formatDecimal(event.target.value)
        });
    };

    handleNewValueForColorantsChange = (event) => {
        if (validationHelper.isMarginMarkupDiscountValid(this.state.type, event.target.value)) {
            this.setState({
                valueForColorants: event.target.value
            });
        }
    };

    handleNewValueForColorantsBlur = (event) => {
        this.setState({
            valueForColorants: validationHelper.formatDecimal(event.target.value)
        });
    };

    handleConfirmButtonClick = () => {
        if (this.props.params === null) {
            this.props.dispatchAddMarginAction(
                this.state.name.trim(),
                this.state.type,
                formatHelper.convertPercentToDecimal(Number(this.state.valueForBases)),
                formatHelper.convertPercentToDecimal(Number(this.state.valueForColorants))
            );
        } else {
            this.props.dispatchEditMarginAction(
                this.props.params.margin.id,
                this.state.name.trim(),
                this.state.type,
                formatHelper.convertPercentToDecimal(Number(this.state.valueForBases)),
                formatHelper.convertPercentToDecimal(Number(this.state.valueForColorants)),
                this.props.params.margin.visible
            );
        }
    };

    getMarginTypeList = () => {
        let marginTypeList = [];
        if (this.state.type === 0) {
            marginTypeList.push(
                <option key={0} value={0}>
                    -
                </option>
            );
        }
        marginTypeList.push(
            <option key={priceTypes.MARGIN_TYPE_MARGIN} value={priceTypes.MARGIN_TYPE_MARGIN}>
                {translate("general.margin")}
            </option>
        );
        marginTypeList.push(
            <option key={priceTypes.MARGIN_TYPE_MARKUP} value={priceTypes.MARGIN_TYPE_MARKUP}>
                {translate("general.markup")}
            </option>
        );
        marginTypeList.push(
            <option key={priceTypes.MARGIN_TYPE_DISCOUNT} value={priceTypes.MARGIN_TYPE_DISCOUNT}>
                {translate("general.discount")}
            </option>
        );

        return marginTypeList;
    };

    getConfirmButton = () => {
        if (this.state.name.trim() === "" || this.state.valueForBases === "" || this.state.valueForColorants === "") {
            return (
                <Button
                    className="disabled-btn"
                    tooltipText={translate("general.missingRequiredItems")}
                    onMouseEnter={tooltipHelper.createTooltip}
                    label={<Translate value="general.confirm" />}
                    svgBefore={imgConfirm}
                    disabled
                />
            );
        }

        return (
            <Button
                onClick={this.handleConfirmButtonClick}
                label={<Translate value="general.confirm" />}
                svgBefore={imgConfirm}
            />
        );
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="col-12 flex flex-align-center-vertical">
                    <div className="col-5">
                        *<Translate value="general.type" />:
                    </div>
                    <div className="col-7 flex flex-align-center-vertical padding-bottom-5">
                        <select
                            className="primary-select col-10"
                            value={this.state.type}
                            onChange={this.handleMarginTypeChange}
                        >
                            {this.getMarginTypeList()}
                        </select>
                    </div>
                </div>
                <div className="col-12 flex flex-align-center-vertical">
                    <div className="col-5">
                        *<Translate value="general.nameTitle" />:
                    </div>
                    <div className="col-7 flex flex-align-center-vertical padding-bottom-5">
                        <Input
                            className="primary-input col-10"
                            type="text"
                            value={this.state.name}
                            onChange={this.handleNewMarginNameChange}
                            onFocus={this.handleInputFocus}
                        />
                    </div>
                </div>
                <div className="col-12 flex flex-align-center-vertical" key="margin-base">
                    <div className="col-5">
                        *<Translate value="marginSettings.valueBase" />:
                    </div>
                    <div className="col-7 flex flex-align-center-vertical padding-bottom-5">
                        <Input
                            className="primary-input col-10 margin-right-5"
                            type="text"
                            value={this.state.valueForBases}
                            onChange={this.handleNewValueForBasesChange}
                            onBlur={this.handleNewValueForBasesBlur}
                            onFocus={this.handleInputFocus}
                        />{" "}
                        <span>%</span>
                    </div>
                </div>
                <div className="col-12 flex flex-align-center-vertical" key="margin-colorant">
                    <div className="col-5 ">
                        *<Translate value="marginSettings.valueColorant" />:
                    </div>
                    <div className="col-7 flex flex-align-center-vertical">
                        <Input
                            className="primary-input col-10 margin-right-5"
                            type="text"
                            value={this.state.valueForColorants}
                            onChange={this.handleNewValueForColorantsChange}
                            onBlur={this.handleNewValueForColorantsBlur}
                            onFocus={this.handleInputFocus}
                        />{" "}
                        <span>%</span>
                    </div>
                </div>
            </React.Fragment>,
            "flex-wrap slim-scroll"
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                {this.getConfirmButton()}
                <CancelButton onClick={this.handleCloseModalClick} />
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(
                    <React.Fragment>
                        <Translate value="general.margin" /> / <Translate value="general.discount" />
                    </React.Fragment>
                )}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{width: "50%"}}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        showMargin: store.pricing.showMargin,
        showMarkup: store.pricing.showMarkup,
        showDiscount: store.pricing.showDiscount
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseMarginModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.EDIT_MARGIN_MODAL));
        },
        dispatchEditMarginAction: (id, name, type, base, colorant, visible) => {
            dispatch(marginActions.editMargin(id, name, type, base, colorant, visible));
        },
        dispatchAddMarginAction: (name, type, base, colorant) => {
            dispatch(marginActions.addMargin(name, type, base, colorant));
        }
    };
};

export default EditMarginModal = connect(mapStoreToProps, mapDispatchToProps)(EditMarginModal);
